
import GHeader from "@/common/components/g-header/";
import XHeader from 'vux/src/components/x-header/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import numberComma from 'vux/src/tools/number/comma.js'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import { mapState, mapActions, mapMutations } from "vuex";
import { filter, common, commonApi } from "@/common/index";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import normalDay from "./normalDay.vue";
import { resetTextBylangKey } from "../../libs/options.js";
import { parseTime, toTimestamp } from "@/common/utils/Date.js";
import userSignInfoMx from "./mixins/userSignInfo.js";
export default {
name: "sign",
directives: {
TransferDom,
},
mixins: [userSignInfoMx],
components: {
GHeader,
XHeader,
XDialog,
normalDay,
PopupPicker,
Group,
Cell,
awesomeSwiper: swiper,
swiperSlide,
Flexbox,
FlexboxItem,
},
data() {
return {

bonusLists: [], // 积分兑换福利列表
currenBonustItem: {}, //当前奖品项
bonusVal: [],
rewardShow: false, //积分领取弹框
pickerShow: false, //奖品栏

signInTab: [
{
title: "积分记录",
img: require("../../assets/image/sign/integral.png"),
link: "/integral",
langKey: "integral",
},
{
title: "兑换现金",
img: require("../../assets/image/sign/coupon.png"),
link: "",
rewardShow: true,
langKey: "cash",
},
{
title: "兑换记录",
img: require("../../assets/image/sign/couponnote.png"),
link: "/exchange",
langKey: "forRecord",
},
{
title: "活动规则",
img: require("../../assets/image/sign/rule.png"),
link: "/rule",
langKey: "rule",
},
],
signSuccess: false, //签到成功弹出
extraSuccess: false, //额外奖励触发
normalList: [], //正常签到个数
extraList: [], //额外签到
successInfo: "", //普通签到返回信息


signInTalentLists: [], // 签到达人列表
updateSignInTalentTimer: null, //更新签到达人列表定时器
gameArray: [],
nameArray: [
"a",
"b",
"c",
"d",
"e",
"f",
"g",
"h",
"i",
"j",
"k",
"l",
"m",
"n",
"o",
"p",
"q",
"r",
"s",
"t",
"u",
"v",
"w",
"x",
"y",
"z",
],
nameArr: [
"a",
"b",
"c",
"d",
"e",
"f",
"g",
"h",
"i",
"j",
"k",
"l",
"m",
"n",
"o",
"p",
"q",
"r",
"s",
"t",
"u",
"v",
"w",
"x",
"y",
"z",
"0",
"1",
"2",
"3",
"4",
"5",
"6",
"7",
"8",
"9",
],
numberA: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
numberS: ["1", "2", "3", "4", "5", "6", "7", "8", "9"],
normalPrizes: [],
extraPrizes: [],
currentPrize: [],
currentPrizeType: 0,
swiperOption: {
direction: "vertical",
slidesPerView: "auto",
loop: true,
freeMode: true,
spaceBetween: 0,
speed: 10000,
autoplay: {
delay: 0,
disableOnInteraction: false,
},
},
};
},
computed: {
...mapState({

frontType: (state) => state.frontType,
customer_service_system_link: (state) =>
state.FrontConfigList.customer_service_system_link,
}),
hasExtraPrize() {
if (this.normalList[this.checkCount]) {
if (typeof this.normalList[this.checkCount].extraPrize == "string") {
return true;
} else {
return false;
}
} else {
return false;
}
},
nextDayCheckInIntegral() {
if (this.normalList[this.checkCount]) {
return this.normalList[this.checkCount].checkInIntegral;
} else {
return 0;
}
},
},
filters: {
numberFilter(num) {
return numberComma(num);
},
jackpotUserName(time) {
return filter.jackpotUserName(time);
},
timeFilter(time) {
return parseTime(time, "{y}-{m}-{d}");
},
},
created() {

this.signInTab = resetTextBylangKey(
this.signInTab,
this.$t("signIn").signInTab,
"title"
);
this.gameArray = JSON.parse(JSON.stringify(this.$t("signIn").gameOptions));
this._getSignInRewardList(); 
this._getBonusExchangeConfigList(); 
},
mounted() {
document.getElementsByTagName("body")[0].style.backgroundColor = "#fff";
},
methods: {
handleSign() {

if (this.diffDay == 0) return;
this.$api.post(
this.$urls.SIGN.userCkeckIn,
{},
(resp) => {
if (resp.data.code === 200) {
this.successInfo = resp.data.data;
if (this.normalList[this.checkCount].extraPrize) {

this.extraSuccess = true;
} else {
this.signSuccess = true;
}
this._getUserIntegralInfo(); 
this._getUserCheckInfo(); 
} else {
this.$vux.toast.show({ text: resp.data.msg, type: "text" });
}
},
(err) => {
console.log(err.message);
}
);
},


handleReward() {
if (this.bonusVal.length === 0) {
this.$vux.toast.show({
text: this.$t("signIn").choosePrize,
type: "cancel",
});
} else {
if (this.point < parseInt(this.currenBonustItem.integral)) {
this.$vux.toast.show({
text: this.$t("signIn").lackOfIntegral,
type: "cancel",
});
} else {
const { integral, id } = this.currenBonustItem;
this.$api.post(
this.$urls.SIGN.bonusIntegralExchange,
{ integral, id },
(resp) => {
if (resp.data.code === 200) {
this.$vux.toast.show({ text: resp.data.data, type: "text" });
this.rewardShow = false;
this._getUserIntegralInfo(); 

} else {
this.$vux.toast.show({ text: resp.data.msg, type: "cancel" });
}
},
(err) => {
this.$vux.toast.show({ text: err, type: "cancel" });
}
);
}
}
},

bonusValChange(v) {

this.currenBonustItem = this.bonusLists[0].filter(
(item) => (item.id = v[0])
)[0];
},

goService() {
this.$router.push({ path: "/Service" });
},

format(value) {
return value.Integral;
},

goRule() {

this.$router.push({ path: "/rule" });
},

goLink({ rewardShow, link }) {
if (rewardShow) this.rewardShow = true;
if (!rewardShow) this.$router.push({ path: link });
},

bonusDialogHide() {

this.rewardShow = false;
this.pickerShow = false;
},

_getSignInRewardList() {

if (this.normalList.length > 0) return;
commonApi.SIGN.checkIntegralConfigList({ pageNo: 1, pageSize: 50 })
.then((res) => {
if (res.data.code !== 200) {
this.$vux.toast.show({ text: res.data.msg, type: "cancel" });
return;
}
let list = res.data.data.list;
if (list.length > 0) {
this.normalPrizes = [];
this.extraPrizes = [];
this.normalList = list.filter((item) => item.fixedDay === null); 
this.extraList = list.filter((item) => item.fixedDay !== null); 
this.normalList.forEach((normalItem, index) => {
this.normalPrizes.push(normalItem.checkInIntegral);
this.extraList.forEach((extraItem) => {
if (normalItem.checkInDay === extraItem.fixedDay) {
normalItem.extraPrize = extraItem.extraPrize;
normalItem.extraPrizeType = extraItem.extraPrizeType;
}
if (index === 0) this.extraPrizes.push(extraItem.extraPrize);
});
});
this.updateSignInTalentLists(); 
}
})
.catch((err) => {
this.$vux.toast.show({ text: err, type: "cancel" });
});
},

_getBonusExchangeConfigList() {



commonApi.SIGN.bonusExchangeConfigList({ pageNo: 1, pageSize: 100 }).then(
(res) => {
if (res.data.data) {
res.data.data.list.map((item) => {
item.name = item.prize;
item.value = item.id;
});
this.bonusLists = [res.data.data.list];
}
}
);
},

updateSignInTalentLists() {
this.signInTalentLists = this.getRandom(); 
this.updateSignInTalentTimer = setInterval(() => {
this.signInTalentLists = this.getRandom(); 
}, 1000 * 60 * 3);
},

getRandom(n) {

const l = n || 10;
let arrAll = [];
let k = Math.ceil(l / 5);
for (let t = 0; t < k; t++) {
let arr = [];
for (let i = 0; i < 5; i++) {
if (t * 5 + i >= l) break;
let game =
this.gameArray[Math.floor(Math.random() * this.gameArray.length)];
let num = parseInt(Math.random() * 2 + 7);
let name =
this.getRandomArrayElements(this.nameArray, 1).join("") +
this.getRandomArrayElements(this.nameArr, num).join("");
let moneyNum = parseInt(Math.random() * 2 + 2);
let money =
this.getRandomArrayElements(this.numberS, 2).join("") +
this.getRandomArrayElements(this.numberA, moneyNum).join("");
let start = parseInt(money.slice(0, 1));
let currentDay = toTimestamp(new Date(), 8);

let prizeNum = Math.ceil(Math.random() * 20);
if (prizeNum < 16) {
this.currentPrizeType = 1;
this.currentPrize = this.normalPrizes;
} else {
this.currentPrizeType = 2;
this.currentPrize = this.extraPrizes;
}
let obj = { id: name, amount: money, game, time: currentDay };
if (this.currentPrizeType == 1) {
let str =
this.currentPrize[
Math.floor(Math.random() * this.currentPrize.length)
];
obj["prize"] = `+${str}${this.$t("signIn").Integral}`;
} else if (this.currentPrizeType == 2) {
let str =
this.currentPrize[
Math.floor(Math.random() * this.currentPrize.length)
];
let currentType = "";
this.extraList.forEach((item) => {
if (item.extraPrize == str) {
currentType = item.extraPrizeType;
}
});
const { Integral, continuously, size, jetton } = this.$t("signIn");
if (currentType == "1") {
obj["prize"] = `${continuously}${str}`;
} else if (currentType == "2") {
obj["prize"] = `${continuously}${str}${size}${jetton}`;
} else if (currentType == "3") {
obj["prize"] = `${continuously}${str}${Integral}`;
}
}
arr.push(obj);
}
arrAll[t] = arr;
}
return arrAll;
},

getRandomArrayElements(arr, count) {
let shuffled = arr.slice(0),
i = arr.length,
min = i - count,
temp,
index;
while (i-- > min) {
index = Math.floor((i + 1) * Math.random());
temp = shuffled[index];
shuffled[index] = shuffled[i];
shuffled[i] = temp;
}
return shuffled.slice(min);
},
},
beforeDestroy() {
clearInterval(this.updateSignInTalentTimer);
},
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/sign/sign.vue